import '../styles/tile.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';

/**
 * It changes the default margin (defined by the CSS) if it prevents placing the element inline.
 * @param {object} $container The jQuery object what is the container of the tile elements.
 */
function adjustMarginToWrap($container) {
    var containerWidth = $container.innerWidth(),
        currentWidth = 0;
    $('.uwr-tile', $container).each(function () {
        var $item = $(this),
            rightMargin = 0,
            isLastItemInRow = false;
        $item.removeClass('uwr-tile-last-column');
        rightMargin = parseInt($item.css('marginRight'), 10);
        currentWidth += parseInt($item.css('marginLeft'), 10);
        currentWidth += $item.outerWidth();
        isLastItemInRow = currentWidth <= containerWidth && containerWidth < (currentWidth + rightMargin);
        if (isLastItemInRow) {
            $item.addClass('uwr-tile-last-column');
            currentWidth = 0;
        } else {
            currentWidth += rightMargin;
        }
    });
}

function initCard() {
    var $element = $(this);
    $element.on('mousedown', function () { $element.addClass('uwr-tile-active'); });
    $element.on('mouseup', function () { $element.removeClass('uwr-tile-active'); });
}

export function init(callback) {
    $('.uwr-tile-container').each(function () {
        var $container = $(this);
        adjustMarginToWrap($container);
        $(window).on('resize', function () {
            adjustMarginToWrap($container);
        });

    });
    $('.uwr-tile-card').each(initCard);
    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/Tile/js/tile.js
// module id = 43
// module chunks = main